module.exports = __webpack_public_path__ + "media/images/official/company_mv_pc-dbc212e4c5cc7578bfec8296e5e49116.jpg";